import { useAviaryTheme } from "@fullscript/aviary-web";

const useIsDS4Enabled = () => {
  const { isDS3 } = useAviaryTheme();

  return !isDS3;
};

export { useIsDS4Enabled };
